var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import ErrorMessage from '../../ErrorMessage';
import classNames from 'classnames';
import react from 'react';
import { useInputTransform } from '../../../../hooks/useInputTransform';
import Label from '../Label';
import * as styles from './inputField.linaria';
const InputField = react.forwardRef((props, ref) => {
    const { id, ariaLabel, ariaAutocomplete, ariaHasPopup, ariaControls, ariaActivedescendant, ariaExpanded, label, hideLabel, height, className, labelClassName, inputClassName, rounded, disabled, leftContent, rightContent, errorMessage, inputTransform, onChange, onClick, onKeyDown } = props, inputProps = __rest(props, ["id", "ariaLabel", "ariaAutocomplete", "ariaHasPopup", "ariaControls", "ariaActivedescendant", "ariaExpanded", "label", "hideLabel", "height", "className", "labelClassName", "inputClassName", "rounded", "disabled", "leftContent", "rightContent", "errorMessage", "inputTransform", "onChange", "onClick", "onKeyDown"]);
    const ariaProps = {
        'aria-expanded': ariaExpanded,
        'aria-haspopup': ariaHasPopup,
        'aria-controls': ariaControls,
        'aria-activedescendant': ariaActivedescendant,
        'aria-autocomplete': ariaAutocomplete,
        'aria-label': ariaLabel,
    };
    const { onInputTransform } = useInputTransform(inputTransform);
    const handleInputChange = (e) => {
        onInputTransform(e);
        if (onChange) {
            onChange(e);
        }
    };
    const handleInputClick = (e) => {
        e.stopPropagation();
        if (onClick) {
            onClick(e);
        }
    };
    const handleOnKeyDown = (e) => {
        if (onKeyDown) {
            onKeyDown(e);
        }
    };
    return (<div className={className}>
      <Label inputId={id} value={label} hideLabel={hideLabel} labelClassName={labelClassName}/>
      <div className={classNames([
            'input-wrapper',
            styles.inputWrapper,
            inputClassName,
            rounded && 'rounded',
            disabled && 'disabled',
            errorMessage && 'error',
        ])}>
        {leftContent}

        <input className={classNames([height])} {...ariaProps} {...inputProps} disabled={disabled} id={id} ref={ref} onChange={handleInputChange} onClick={handleInputClick} onKeyDown={handleOnKeyDown}/>
        {rightContent && <div className="input-r-content">{rightContent}</div>}
      </div>
      <ErrorMessage id={id} errorMessage={errorMessage}/>
    </div>);
});
InputField.defaultProps = {
    type: 'text',
    min: null,
    id: null,
    name: null,
    hideLabel: false,
    height: 'default',
    className: null,
    labelClassName: null,
    placeholder: undefined,
    value: undefined,
    disabled: false,
    readOnly: false,
    rounded: false,
    role: undefined,
    ariaLabel: undefined,
    ariaAutocomplete: undefined,
    ariaControls: undefined,
    ariaHasPopup: undefined,
    ariaActivedescendant: undefined,
    ariaExpanded: undefined,
    leftContent: null,
    rightContent: null,
    errorMessage: undefined,
};
export default InputField;
